// Chart colours. Series hues come in a fixed order (checked for colour-blind separation on white);
// the brand blue is too grey to tell series apart, so it is only used for single-series bars
export const SERIES = {
  blue: "#2a78d6",
  orange: "#eb6834",
  aqua: "#1baf7a",
  yellow: "#eda100",
};

// Outcomes keep the same colour on every chart, always next to their label
export const STATUS = {
  good: "#0ca30c",
  warning: "#fab219",
  critical: "#d03b3b",
};

// For "unknown" or "no longer active" parts that should recede
export const NEUTRAL = "#94a3b8";
